import './Navbar.css';

const Navbar = () => {
    return (
        <div className="navbar">
            <img src="./images/navbar_sopranos.png" alt='logo' />
        </div>
    );
}

export default Navbar;